import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import {
  sportAnalyticTag,
  useSportContext,
} from '@sorare/core/src/contexts/sport';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import { MarketRoot } from '@sorare/marketplace/src/components/market/ui';
import { useScoutingCenterSo5Fixture } from '@sorare/marketplace/src/hooks/useScoutingCenterSo5Fixture';
import { SCOUTING_CENTER_CONFIG_BY_SPORT } from '@sorare/marketplace/src/lib/scoutingCenterFilters';
import {
  AdvancedPlayerSearch,
  BackendAdvancedPlayerSearch,
} from '@sorare/marketplace/src/searchCommonPlayer/AdvancedPlayerSearch';

import { Header } from '#src/components/scoutingCenter/stats/Header/index.tsx';

export const ScoutingCenter = () => {
  const { sport } = useSportContext();
  const { so5FixtureSlug, loading } = useScoutingCenterSo5Fixture(sport);
  const {
    flags: { useGraphqlScoutingCenter = false },
  } = useFeatureFlags();
  const scoutingConfig = SCOUTING_CENTER_CONFIG_BY_SPORT[sport];
  const {
    sorts,
    filters,
    dropdownFilters,
    backendCardFilters,
    backendDropdownFilters,
  } = scoutingConfig;
  const useBackendSearch =
    useGraphqlScoutingCenter && backendCardFilters && backendDropdownFilters;
  const lastOwnedCardsRarities = [
    Rarity.limited,
    Rarity.rare,
    Rarity.super_rare,
    Rarity.unique,
  ];

  return (
    <MarketRoot>
      <Vertical gap={3}>
        <Header sport={sport} />
        <div>
          {useBackendSearch ? (
            <BackendAdvancedPlayerSearch
              sport={sport}
              defaultHitsPerPage={20}
              sorts={sorts}
              defaultSort={sorts[0]}
              cardFilters={backendCardFilters}
              dropdownFilters={backendDropdownFilters}
              analyticsTags={['Scouting-center', sportAnalyticTag[sport]]}
              topic={{ type: 'scoutingCenter', label: '' }}
              attributesToRetrieve={['slug']}
              so5FixtureSlug={so5FixtureSlug}
              shouldSkip={loading}
              lastOwnedCardsRarities={lastOwnedCardsRarities}
            />
          ) : (
            <AdvancedPlayerSearch
              sport={sport}
              defaultHitsPerPage={20}
              sorts={sorts}
              defaultSort={sorts[0]}
              cardFilters={filters}
              dropdownFilters={dropdownFilters}
              analyticsTags={['Scouting-center', sportAnalyticTag[sport]]}
              topic={{ type: 'scoutingCenter', label: '' }}
              attributesToRetrieve={['slug']}
              so5FixtureSlug={so5FixtureSlug}
              shouldSkip={loading}
              lastOwnedCardsRarities={lastOwnedCardsRarities}
            />
          )}
        </div>
      </Vertical>
    </MarketRoot>
  );
};
